import CustomCard from '../../../../components/CustomCard';
import { PersonOutlinedChip, SecurityIcon, SettingsIcon } from '../../../../components/buttons/IconButtons';
import { UserRestrictionItem } from './UserRestrictionItem';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const Employees = (props) => {
    const {
        t,
        extraDataEmployee,
        setExtraDataEmployee,
        sendEmailWhenCreateEmployee,
        setSendEmailWhenCreateEmployee,
        sendEmailWhenUpdateEmployee,
        setSendEmailWhenUpdateEmployee,
        validationEmployee,
        livenessEmployee,
        biometricEmployee,
        setValidationEmployee,
        setLivenessEmployee,
        setBiometricEmployee,
    } = props;
    return (
        <div className='col-12 col-md-6'>
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <div className={'d-flex align-items-center m-2'}>
                    <div className='h-32px w-32px'>
                        <PersonOutlinedChip className='w-h-24px' />
                    </div>
                    <p className={'fs-18px ibl-font-w-600 font-color-general-950 text-left pl-1'}>{t('employees')}</p>
                </div>

                <div className={'border-bottom-shades-300'} />
                <CustomCard classCard={'card-border-8px mt-3 mb-3'} classContent={'p-0'} classes={'m-2'}>
                    <div className={'d-flex align-items-center m-2'}>
                        <div className='h-32px w-32px'>
                            <SettingsIcon className='w-h-24px icon-color-general-950' />
                        </div>
                        <p className={'fs-14px ibl-font-w-600 font-color-general-950 text-left pl-1'}>
                            {t('general_configuration')}
                        </p>
                    </div>
                    <div className={'border-bottom-shades-300'} />
                    <div className='m-3'>
                        <UserRestrictionItem
                            id="cb_e_extended_data_collection"
                            name="extendedDataCollection"
                            title='extended_data_collection'
                            description='activates_custom_headers_configuration'
                            checked={extraDataEmployee}
                            onChange={(e) => setExtraDataEmployee(e.target.checked)}
                        />
                        <UserRestrictionItem
                             id="cb_e_profile_creation_email"
                            name='profileCreationEmail'
                            title='profile_creation_email'
                            description='profile_creation_email_description'
                            checked={sendEmailWhenCreateEmployee}
                            onChange={(e) => setSendEmailWhenCreateEmployee(e.target.checked)}
                        />
                        <UserRestrictionItem
                            id="cb_e_profile_update_notifications"
                            name='profileUpdateNotifications'
                            title='profile_update_notifications'
                            description='profile_update_notifications_description'
                            checked={sendEmailWhenUpdateEmployee}
                            onChange={(e) => setSendEmailWhenUpdateEmployee(e.target.checked)}
                        />
                    </div>
                </CustomCard>
                <CustomCard classCard={'card-border-8px mb-3'} classContent={'p-0'} classes={'m-2'}>
                    <div className={'d-flex align-items-center m-2'}>
                        <div className='h-32px w-32px'>
                            <SecurityIcon className='w-h-24px icon-color-general-950' />
                        </div>
                        <p className={'fs-14px ibl-font-w-600 font-color-general-950 text-left pl-1'}>
                            {t('security_validation')}
                        </p>
                    </div>
                    <div className={'border-bottom-shades-300'} />
                    <div className='m-3'>
                        <UserRestrictionItem
                             id="cb_e_require_identity_verification"
                            name='requireIdentityVerification'
                            title='require_identity_verification'
                            description='require_identity_verification_description'
                            checked={validationEmployee}
                            onChange={(e) => setValidationEmployee(e.target.checked)}
                        />
                        <UserRestrictionItem
                            id="cb_e_active_liveness"
                            name='activeLiveness'
                            title='active_liveness'
                            description='active_liveness_description'
                            checked={livenessEmployee}
                            onChange={(e) => setLivenessEmployee(e.target.checked)}
                        />
                        <UserRestrictionItem
                            id="cb_e_biometric_enforcement"
                            name='biometricEnforcement'
                            title='biometric_enforcement'
                            description='biometric_enforcement_description'
                            checked={biometricEmployee}
                            onChange={(e) => setBiometricEmployee(e.target.checked)}
                        />
                    </div>
                </CustomCard>
            </CustomCard>
        </div>
    );
};

export default Employees;
